import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";

import { wrapper as wrap } from "../switchless-redux-actions";

import statsCheckpoint from "../actions/api/statsCheckpoint/reducers";
import forms from "../actions/api/forms/reducers";
import exports from "./exports";
import attendee from "./attendee";
import checkpoint from "./checkpoint";
import performances from "./performances";
import equipment from "./equipment";
import event from "./event";
import network from "./network";
import organization from "./organization";
import product from "./product";
import undo from "./undo";
import zone from "./zone";
import { clearApp } from "./reset";
import integrations from "./integrations";

const reducers = [
	// Reset when leaving an orga or login out
	clearApp,

	wrapperReducer(
		combineReducers({
			form: formReducer,
			network: wrap(network, "NetworkReducer"),
			checkpoint: wrap(checkpoint, "CheckpointReducer"),
			event: wrap(event, "EventReducer"),
			undo: wrap(undo, "UndoReducer"),
			zone: wrap(zone, "ZoneReducer"),
			organization: wrap(organization, "OrganizationReducer"),
			attendee: wrap(attendee, "AttendeeReducer"),
			product: wrap(product, "ProductReducer"),
			performances: wrap(performances, "PerformanceReducer"),
			equipment: wrap(equipment, "EquipmentReducer"),
			exports,
			statsCheckpoint: wrap(statsCheckpoint, "StatsCheckpointReducer"),
			forms,
			integrations
		})
	)
];

/**
 * Function to wrap the combineReducers and set the new state with the previousState. We do that because the function 'combineReducers' create a new state and delete the existing state
 * @param  {function} combineReducers - The reducers that are combined
 * @return {function} - A reducer function
 */
function wrapperReducer(combineReducers) {
	return (state, action) => {
		const nextState = combineReducers(state, action);
		if (nextState === state) {
			return state;
		}
		return Object.assign({}, state, nextState);
	};
}

/**
 * Apply each reduce function to the state
 * @param {Object} state - The state
 * @param {Object} action - The action
 * @returns {Object} The state
 */
export default function reducerFn(state, action) {
	return reducers.reduce(
		(previousState, reducer) => reducer(previousState, action),
		state
	);
}
